module.exports = __webpack_public_path__ + "static/media/heart_filled.bffd0467.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/statistics/heart_filled.svg
// module id = 276
// module chunks = 0